export type WebsiteConfig = {
  title: string;
  description: string;
  coverImage?: string;
  logo: string;
  /**
   * Specifying a valid BCP 47 language helps screen readers announce text properly.
   * See: https://dequeuniversity.com/rules/axe/2.2/valid-lang
   */
  lang: string;
  /**
   * Site full path, no ending slash!
   */
  siteUrl: string;
  /**
   * Short wordmark for nav (personal brand)
   */
  shortName: string;
  /**
   * full url, no username
   */
  facebook?: string;
  /**
   * full url, no username
   */
  twitter?: string;
  /**
   * hide or show all email subscribe boxes
   */
  showSubscribe: boolean;
  /**
   * create a list on mailchimp and then create an embeddable signup form. this is the form action
   */
  mailchimpAction?: string;
  /**
   * this is the hidden input field name
   */
  mailchimpName?: string;
  /**
   * name and id of the mailchimp email field
   */
  mailchimpEmailFieldName?: string;
  /**
   * hide or show contact form modal
   */
  showContact: boolean;
  /**
   * Contact form configuration
   * Choose one integration method:
   * - 'email': Uses mailto link (requires email address)
   * - 'formspree': Uses Formspree.io service (requires form ID)
   * - 'netlify': Uses Netlify Forms (requires netlify attribute)
   * - 'webhook': Uses custom webhook URL (requires webhookUrl)
   * - 'api': Uses custom API endpoint (requires apiEndpoint)
   */
  contactFormIntegration?: 'email' | 'formspree' | 'netlify' | 'webhook' | 'api';
  /**
   * Email address for mailto integration
   */
  contactEmail?: string;
  /**
   * Formspree form ID (e.g., 'your-form-id' for https://formspree.io/f/your-form-id)
   */
  formspreeFormId?: string;
  /**
   * Webhook URL for custom integrations (Zapier, Make.com, etc.)
   */
  webhookUrl?: string;
  /**
   * Custom API endpoint URL
   */
  apiEndpoint?: string;
  /**
   * Available services to show in the dropdown
   */
  contactServices?: string[];
  /**
   * Meta tag for Google Webmaster Tools
   */
  googleSiteVerification?: string;
  /**
   * Appears alongside the footer, after the credits
   */
  footer?: string;
  /**
   * Shows all post tags in main index view and post view if true
   * Otherwise only shows first (primary) tag
   */
  showAllTags: boolean;
};

const config: WebsiteConfig = {
  title: 'David Martínez',
  shortName: 'DM',
  description:
    'David Martínez — Software Engineer. Scalable systems, performance, and reliable delivery.',
  coverImage: 'img/blog-cover.png',
  logo: 'img/ghost-logo.png',
  lang: 'en',
  siteUrl: 'https://davidmrtz-dev.netlify.app',
  showSubscribe: false,
  mailchimpAction: undefined,
  mailchimpName: undefined,
  mailchimpEmailFieldName: undefined,
  showContact: false,
  contactFormIntegration: 'email',
  contactEmail: 'margasolutionsmx@gmail.com',
  contactServices: ['Engineering collaboration', 'Technical consultation', 'Other'],
  googleSiteVerification: undefined,
  footer: 'Software Engineer',
  showAllTags: true,
};

export default config;
